export const informationPagesClasses = 'u-scroll-content-wrapper';
